/* eslint-disable eqeqeq */
import { Button, ButtonGroup, Dialog, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { useEffect, useMemo, useCallback } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { createNewTicket, getDriver, getExtrptById, getInventory, getInvoiceForm, getLoadingType, getLTP, putExtrpt, getVehicle, getProduct } from "../../../../services/api";
import moment from "moment";
import { FilterBy } from "../../../commons/filter.component";
import { useSelector } from "react-redux";
import TicketPreview from "../../commons/ticketPreview.component";
import ButtonWithAPICall from "../../../commons/ButtonWithAPICall.component";
import { sumOfField } from "../../../../services/libService";
import CustomDatePicker from "../../../commons/CustomDatePicker";

const ExtrptDetail = ({ onClose, onCreateResponse }) => {
  // pop up detail
  const user = useSelector((state) => state.user.data);
  const [t] = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState();
  const [allProducts, setAllProducts] = useState([]);
  const [inputData, setInputData] = useState({
    inventory_cert: "",
    ext_serial: "",
    ext_number: "",
    contract_no: "",
    contract_date: "",
    cert_date: "",
    products: [],
    ext_inv_serial: "",
  });
  const [isDialogOpen, setDialogOpen] = useState(false);
  let a = data?.ext_tanks && JSON.parse(data.ext_tanks);
  const ext_tanks = inputData.vehicle?.tanks && JSON.parse(inputData.vehicle.tanks).map((item, index) => ({ ...item, lit: a?.[index]?.truck_tank.level_sensor }));
  const dataForPreview = useMemo(() => {
    if (data)
      return {
        receipt: {
          ...inputData,
          // date: inputData.contract_date,
          form_no: inputData.invoiceForm?.form,
          serial: inputData.invoiceForm?.series,
          driver: inputData.driver?.name,
          license_plate: inputData.vehicle?.license_plate,
          from_inventory_name: inputData.from_inventory?.name,
          to_inventory_name: inputData.to_inventory?.name,
          receiptproducts: undefined,
          orderno: data.order_no,
          seal: data.seal,
          inventory_cert: inputData.inventory_cert,
          date: data.bill_order_date,
        },
        receiptproduct: inputData.products?.map((item) => ({
          ...item,
          lit: parseFloat(item.lit),
        })),
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDialogOpen]);
  const handleChangeProduct = (index, keyName, value) => {
    let newProduct = [...inputData.products];
    newProduct[index][keyName] = value;
    switch (keyName) {
      case "quantity":
        switch (newProduct[index].unit?.id) {
          case 21:
            newProduct[index].gallon = Math.round(value * 0.26417218);
            newProduct[index].lit = value;
            break;
          case 22:
            newProduct[index].lit = Math.round(value / 0.26417218);
            newProduct[index].gallon = value;
            break;
          default:
            break;
        }
        break;
      case "unit":
        switch (value.id) {
          case 21:
            newProduct[index].lit = newProduct[index].quantity;
            newProduct[index].gallon = Math.round(newProduct[index].quantity * 0.26417218);
            break;
          case 22:
            newProduct[index].gallon = newProduct[index].quantity;
            newProduct[index].lit = Math.round(newProduct[index].quantity / 0.26417218);
            break;
          default:
            break;
        }
        break;
      case "temp":
        newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "4.5 - 52" : undefined;
        break;
      case "d15":
        newProduct[index].density_error = newProduct[index].d15 < 0.701 || newProduct[index].d15 > 0.873 ? "7010 - 8730" : undefined;
        break;
      default:
        break;
    }
    setInputData((prev) => ({ ...prev, products: newProduct }));
  };
  const handleSubmit = async (e) => {
    let object = {
      startdate: moment(inputData.bill_order_date).format("YYYY-MM-DD HH:mm"),
      enddate: moment(inputData.bill_order_date).format("YYYY-MM-DD HH:mm"),
      billdate: moment(inputData.bill_order_date).format("YYYY-MM-DD HH:mm"),
      contract_date: inputData.contract_date ? moment(inputData.contract_date).format("YYYY-MM-DD HH:mm") : undefined,
      contract_no: inputData.contract_no || undefined,
      serial: inputData.invoiceForm?.series,
      form_no: inputData.invoiceForm?.form,
      driver: inputData.driver?.name,
      driver_id: inputData.driver?.id,
      l15: sumOfField(inputData.products, "l15"),
      kg: sumOfField(inputData.products, "kg"),
      lit: sumOfField(inputData.products, "lit"),
      usg: sumOfField(inputData.products, "gallon"),
      from_inventory_id: inputData.from_inventory?.id,
      to_inventory_id: inputData.ltp?.to_inventory_id,
      vehicle_id: inputData.vehicle?.id,
      // saletype_id: inputData.saletype?.id,
      loadingtype_id: inputData.loadingtype?.id,
      imp_organization_id: inputData.to_inventory?.organization_id,
      vehicle: inputData.vehicle?.license_plate,
      receiptproducts: inputData.products.map((item) => ({ ...item, unit: item.unit, product_name: item.product_name, density: item.density || null })),
      product_id: data.product_id,
      ltp_id: inputData.ltp?.id,
      ext_inv_serial: data.order_no,
      saletype_id: data.saletype_id,
      orderno: data.order_no,
      ext_vh_tanks: ext_tanks,
      cert_date: inputData.cert_date,
      inventory_cert: inputData.inventory_cert,
      extrpt_id: +id,
    };
    await getInventory().then((res) => {
      if (res.code !== 200) return;
      object.imp_organization_id = res.data.find((item) => item.id == inputData.ltp?.to_inventory_id)?.organization_id;
    });
    return createNewTicket(object);
  };
  const getData = () => {
    getExtrptById(id).then((res) => {
      if (res.code === 200) {
        setData(res.data);
        setInputData((prev) => ({
          ...prev,
          cert_date: res.data.cert_date,
          inventory_cert: res.data.inventory_cert || "",
          ext_inv_serial: res.data.ext_inv_serial,
          products: JSON.parse(res.data.products),
          contract_no: res.data.contract_no || "",
          contract_date: res.data.contract_date ? moment(res.data.contract_date).format("YYYY-MM-DD[T]HH:mm") : "",
          ext_serial: res.data.ext_serial || "",
          ext_number: res.data.ext_number || "",
        }));
      } else onClose?.();
    });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      putExtrpt(id, {
        receipt_id: res.data.id,
        products: inputData.products,
        inventory_cert: inputData.inventory_cert,
        cert_date: inputData.cert_date,
        ext_serial: inputData.ext_serial,
        ext_number: inputData.ext_number,
      }).then((ress) => {
        setData(ress.data);
        onCreateResponse?.();
      });
    } else if (res.code == 406) {
      getData();
      onCreateResponse?.();
    }
  };
  useEffect(() => {
    if (!id) {
      setData(null);
      setInputData({
        inventory_cert: "",
        ext_serial: "",
        ext_number: "",
        contract_no: "",
        contract_date: "",
        cert_date: "",
        products: [],
        ext_inv_serial: "",
      });
      return;
    }
    getData();

    getProduct({ status: 1 }).then((res) => {
      if (res.code === 200) {
        setAllProducts(res.data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const updateProductNames = useCallback(() => {
    if (inputData?.ltp?.product_id && allProducts.length > 0) {
      const updateProduct = allProducts.find((item) => item.id == inputData?.ltp?.product_id);

      if (updateProduct) {
        setInputData((prev) => {
          const newProducts = prev.products.map((item) => {
            return { ...item, product_name: updateProduct.name };
          });

          return {
            ...prev,
            product: updateProduct,
            products: newProducts,
          };
        });
      }
    }
  }, [inputData?.ltp?.product_id, allProducts]);

  useEffect(() => {
    updateProductNames();
    setData((prev) => ({ ...prev, loadingtype_id: inputData?.ltp?.loadingtype_id, product_id: inputData?.ltp?.product_id, product_name: inputData?.ltp?.product_name }));
  }, [updateProductNames, inputData?.ltp?.loadingtype_id]);

  return (
    <Dialog open={Boolean(id)} onClose={onClose} fullWidth maxWidth={false}>
      {data && (
        <div style={{ padding: 10, display: "flex", minHeight: "500px" }}>
          <div style={{ width: "30%" }}>
            <div style={{ background: "#004c98", color: "white", borderRadius: 5, paddingLeft: 10, textTransform: "uppercase", fontWeight: 600 }}>Thông tin kho đầu nguồn</div>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td width="50%">Ext Rpt ID</td>
                  <td width="50%">{data.extsys_id}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>

                <tr>
                  <td width="50%">Lệnh điều động số</td>
                  <td width="50%">{data.order_no}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Thông tin kho xuất</td>
                  <td>{data.inventory}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Bồn xuất</td>
                  <td>{data.tank_no}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Ngày xuất phiếu</td>
                  <td>{moment(data.bill_order_date).format("DD/MM/YYYY")}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Giờ xuất phiếu</td>
                  <td>{moment(data.bill_order_date).format("HH:mm:ss")}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Chứng chỉ xuất</td>
                  <td>{data.inventory_cert}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Ngày xuất chứng chỉ</td>
                  <td>{data.cert_date && moment(data.cert_date).format("DD/MM/YYYY")}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>

                <tr>
                  <td>Số niêm</td>
                  <td>{data.seal}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Số lô</td>
                  <td>{data.batch_no}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Loại hình xuất hàng</td>
                  <td>{data.loadingtype}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Đơn vị vận tải</td>
                  <td>{data.provider}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Người lái</td>
                  <td>{data.driver}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Biển đăng ký</td>
                  <td>{data.truck_no}</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <Divider />
                  </td>
                </tr>
                <tr>
                  <td>Trạng thái</td>
                  <td>{t(data.status)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ width: "70%", padding: "0 10px" }}>
            <div style={{ background: "#bac8d3", borderRadius: 5, paddingLeft: 10, textTransform: "uppercase", fontWeight: 600 }}>Thông tin duyệt phiếu xuất kho kiêm vận chuyển nội bộ</div>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gridGap: 20, margin: "20px 0 10px" }}>
              <FilterBy
                label={t("Tuyến vận chuyển")}
                getDataFunc={() =>
                  user &&
                  getLTP({
                    org_id: user?.organization_id,
                    status: 1,
                    from_inventory_id: data?.from_inventory_id || undefined,
                    loadingtype_id: data?.loadingtype_id || undefined,
                    product_id: data?.product_id || undefined,
                  })
                }
                getDataDependencies={[user]}
                setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, ltp: option.find((item) => item.id === data.ltp_id) || null }))}
                triggerSetDefaultFunc={Boolean(data.ltp_id)}
                value={inputData.ltp}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, ltp: newValue }))}
                getOptionLabel={(option) => `${option.id} - ${option.code}` || ""}
                disabled={Boolean(data.receipt_id)}
              />
              <FilterBy
                getDataFunc={() => getInventory({ status: 1 })}
                setDefaultFunc={(option) =>
                  setInputData((prev) => ({ ...prev, from_inventory: option.find((item) => (data?.from_inventory_id ? data.from_inventory_id == item.id : item.id == prev.ltp?.from_inventory_id)) }))
                }
                triggerSetDefaultFunc={true}
                setDefaultDependencies={[inputData.ltp]}
                value={inputData.from_inventory}
                label={t("Kho xuất")}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, from_inventory: newValue, products: prev.products.map((item) => ({ ...item, tank: null })) }))}
                disabled
              />
              <FilterBy
                getDataFunc={() => getInventory({ status: 1 })}
                value={inputData.to_inventory}
                setDefaultFunc={(_, option) => setInputData((prev) => ({ ...prev, to_inventory: option.find((item) => item.id === prev.ltp?.to_inventory_id) }))}
                setDefaultDependencies={[inputData.ltp]}
                triggerSetDefaultFunc={true}
                label={t("Kho nhập")}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, to_inventory: newValue }))}
                disabled
              />

              <FilterBy
                fullWidth
                disabled={Boolean(data.receipt_id)}
                label={t("Phương tiện")}
                getDataFunc={() => getVehicle({ status: 1, end_date: moment(Date.now()).format("YYYY-MM-DD"), groupvehicle_id: 455911 })}
                setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, vehicle: option.find((item) => item.id == data.vehicle_id) }))}
                triggerSetDefaultFunc={Boolean(data.vehicle_id)}
                value={inputData.vehicle}
                getOptionLabel={(option) => `${option.id} - ${option.license_plate}` || ""}
                filter={(option) => option.provider_id && JSON.parse(option.tanks)?.length}
                onChange={(e, newValue) =>
                  setInputData((prev) => ({ ...prev, vehicle: newValue, driver: null, ext_vh_tanks: newValue && JSON.parse(newValue.tanks).map((item) => ({ ...item, lit: 0 })) }))
                }
              />
              <FilterBy
                fullWidth
                disabled={!inputData.vehicle || data.receipt_id}
                label={t("Người điều khiển")}
                getDataFunc={() => inputData.vehicle && getDriver({ provider_id: inputData.vehicle?.provider_id || undefined, status: 1 })}
                getDataDependencies={[inputData.vehicle]}
                filter={(option) => option.provider_id == inputData.vehicle?.provider_id}
                setDefaultFunc={(_, option) => setInputData((prev) => ({ ...prev, driver: option.find((item) => item.id == data.driver_id) || null }))}
                triggerSetDefaultFunc={Boolean(data.driver_id)}
                value={inputData.driver}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, driver: newValue }))}
              />
              <FilterBy
                disabled
                fullWidth
                label={t("Phương thức nhập")}
                getDataFunc={() => getLoadingType({ status: 1 })}
                setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, loadingtype: option.find((item) => item.id == data?.loadingtype_id) || null }))}
                setDefaultDependencies={[inputData.ltp]}
                triggerSetDefaultFunc={Boolean(data.loadingtype_id)}
                value={inputData.loadingtype}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, loadingtype: newValue }))}
              />
              <FilterBy
                fullWidth
                disabled={Boolean(data.receipt_id)}
                label={t("Form số")}
                setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, invoiceForm: option.find((item) => (data.form_no ? item.form == data.form_no : item.id === 3)) || null }))}
                triggerSetDefaultFunc
                getDataFunc={() => getInvoiceForm({ status: 1 })}
                value={inputData.invoiceForm}
                getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, invoiceForm: newValue }))}
              />
              <TextField
                disabled={Boolean(data.inventory_cert)}
                fullWidth
                label={t("Chứng chỉ xuất")}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setInputData((prev) => ({ ...prev, inventory_cert: e.target.value }))}
                value={inputData.inventory_cert || ""}
              />
              <CustomDatePicker
                format="DD/MM/YYYY"
                disabled={Boolean(data.cert_date)}
                label={t("Ngày xuất chứng chỉ")}
                value={inputData.cert_date}
                onChange={(value) => setInputData((prev) => ({ ...prev, cert_date: value }))}
                sx={{ width: "100%" }}
              />
              <TextField
                disabled={Boolean(data.ext_serial)}
                fullWidth
                label={t("Ký hiệu phiếu xuất trả KDN")}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setInputData((prev) => ({ ...prev, ext_serial: e.target.value }))}
                value={inputData.ext_serial || ""}
              />
              <TextField
                disabled={Boolean(data.ext_number)}
                fullWidth
                label={t("Số phiếu phiếu xuất trả KDN")}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setInputData((prev) => ({ ...prev, ext_number: e.target.value }))}
                value={inputData.ext_number || ""}
              />
            </div>
            <div align="left" style={{ margin: "10px 0", display: "flex" }}>
              <div style={{ width: "auto" }}>
                <b>{t("Khoảng cách tầm mức")}:&nbsp;</b>
              </div>

              {Boolean(ext_tanks?.length) && (
                <div style={{ display: "grid", gridTemplateColumns: `repeat(${ext_tanks.length}, 1fr)`, gridColumnGap: 20 }}>
                  {ext_tanks?.map((item, index) => (
                    <div key={index}>
                      {item.code}: {item.lit};
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={{ background: "#bac8d3", borderRadius: 5, paddingLeft: 10, textTransform: "uppercase", marginBottom: 10, fontWeight: 600 }}>Thông tin hàng hóa nhập</div>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>STT</TableCell>
                    <TableCell>Tên hàng hóa</TableCell>
                    <TableCell>Số lượng</TableCell>
                    <TableCell>Nhiệt độ</TableCell>
                    <TableCell>D15</TableCell>
                    <TableCell>VCF</TableCell>
                    <TableCell>WCF</TableCell>
                    <TableCell>Số lượng L15</TableCell>
                    <TableCell>Số lượng KG</TableCell>
                    <TableCell>Cần xuất</TableCell>
                    <TableCell>Bồn xuất</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inputData.products?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.product_name}</TableCell>
                      <TableCell>{item.quantity?.toLocaleString()}</TableCell>
                      <TableCell>{+item.temp?.toFixed(2)}</TableCell>
                      <TableCell>{+item.d15?.toFixed(4)}</TableCell>
                      <TableCell>{+item.vcf?.toFixed(4)}</TableCell>
                      <TableCell>{+item.wcf?.toFixed(4)}</TableCell>
                      <TableCell>{item.l15?.toLocaleString()}</TableCell>
                      <TableCell>{item.kg?.toLocaleString()}</TableCell>
                      <TableCell>{item.meter_id ? item.meter_id : ""}</TableCell>
                      <TableCell>
                        <FilterBy
                          disabled={Boolean(data.receipt_id)}
                          value={item.tank || null}
                          disableClearable
                          getDataFunc={() => Promise.resolve({ data: inputData.from_inventory?.tanks, code: 200 })}
                          getDataDependencies={[inputData.from_inventory]}
                          setDefaultFunc={(option) =>
                            handleChangeProduct(
                              index,
                              "tank",
                              option.find((item) => item.id == inputData.products?.[index]?.tank?.id)
                            )
                          }
                          triggerSetDefaultFunc={Boolean(inputData.products?.[index]?.tank?.id)}
                          getOptionLabel={(option) => option.code || ""}
                          style={{ minWidth: "150px" }}
                          onChange={(e, newValue) => handleChangeProduct(index, "tank", newValue)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ marginTop: 10, fontWeight: 600 }}>
              Tổng:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;L15: {Intl.NumberFormat("de-DE").format(data.l15)}&nbsp;&nbsp;&nbsp;&nbsp;KG: {Intl.NumberFormat("de-DE").format(data.kg)}&nbsp;&nbsp;&nbsp;&nbsp;Lit:{" "}
              {Intl.NumberFormat("de-DE").format(data.lit)}&nbsp;&nbsp;&nbsp;&nbsp;USG: {Intl.NumberFormat("de-DE").format(data.usg)}
            </div>
            <div align="left" style={{ marginTop: 10 }}>
              {data.receipt_id ? (
                <div>
                  Số phiếu tạo:{" "}
                  <Link to={`/ticket/${data.receipt_id}`} style={{ cursor: "pointer", textDecoration: "underline", color: "#3a79de" }}>
                    {data.code}
                  </Link>
                </div>
              ) : (
                <ButtonGroup color="info" disabled={Boolean(data.receipt_id)}>
                  {/* button is disabled if required field is empty */}
                  <Button variant="contained" onClick={() => setDialogOpen(true)}>
                    Xem trước
                  </Button>
                  <ButtonWithAPICall
                    variant="contained"
                    // disabled={}
                    api={handleSubmit}
                    response={handleResponse}
                  >
                    Tạo phiếu
                  </ButtonWithAPICall>
                </ButtonGroup>
              )}
            </div>
          </div>

          <Dialog scroll="body" PaperProps={{ style: { minWidth: "984px" } }} open={isDialogOpen} onClose={() => setDialogOpen(false)}>
            <TicketPreview data={dataForPreview} />
          </Dialog>
        </div>
      )}
    </Dialog>
  );
};

export default ExtrptDetail;
